/* eslint-disable */
import React, { FC, ReactElement } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ErrorCustom from './components/common/ErrorBoundary/ErrorCustom';
import CustomSpinner from './components/common/Spinner';
import SiteContentProvider from './components/hoc/SiteContentProvider';

import NewOfferError from './components/NewOfferError/NewOfferError';
import Layout from './features/Layout/Layout';
import DefaultPinOptFlowContainer from './features/DefaultPinOptFlow/PinSearchContainer';
import OfferValidateContainer from './features/OfferValidateContainer/OfferValidateContainer';
import PaymentDetailsContainer from './features/OfferPaymentContainer/PaymentDetailsContainer';
import NewOfferThankYou from './features/newOfferThankYou/NewOfferThankYou';
import PinOptOfferDetailsContainer from './features/PinOptOfferDetails/PinOptOfferDetailsContainer';
import PinOptFlowError from './features/PinOptFlowError/PinOptFlowError';

import Metadata from './features/siteTheme/Metadata';
import { getCurrentBrand } from './util/errorString';
import {
  OFFER_VALIDATE_PATH,
  PIN_OPT_ERROR,
  NEWOFFER_ERROR_PATH,
  NEWOFFER_PAYMENT_PATH,
  PIN_OPT_OFFER_DETAILS_PATH,
  NEWOFFER_THANKYOU_PATH,
} from './util/strings';
interface IProps {
  lang: string;
}
const Main: FC<any> = (props: IProps): ReactElement => {
  return (
    <SiteContentProvider>
      <Metadata currentBrand={getCurrentBrand()}></Metadata>
      <CustomSpinner></CustomSpinner>
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route path={NEWOFFER_ERROR_PATH} element={<NewOfferError />} />
            <Route path={PIN_OPT_ERROR} element={<PinOptFlowError />} />
            <Route path={OFFER_VALIDATE_PATH} element={<OfferValidateContainer />} />
            <Route path={PIN_OPT_OFFER_DETAILS_PATH} element={<PinOptOfferDetailsContainer />} />
            <Route path={NEWOFFER_PAYMENT_PATH} element={<PaymentDetailsContainer />} />
            <Route path={NEWOFFER_THANKYOU_PATH} element={<NewOfferThankYou />} />
            <Route path="/:pinId?" element={<DefaultPinOptFlowContainer />} />
          </Route>
          <Route path="/*" element={<ErrorCustom />} />
        </Routes>
      </Router>
    </SiteContentProvider>
  );
};

export default Main;
